import {
  AcademicCapIcon,
  ArchiveBoxXMarkIcon,
  BookOpenIcon,
  BriefcaseIcon,
  ClipboardDocumentListIcon,
  CogIcon,
  CubeIcon,
  CubeTransparentIcon,
  DocumentDuplicateIcon,
  PresentationChartBarIcon,
  QuestionMarkCircleIcon,
  ShoppingCartIcon,
  UserCircleIcon,
  UserIcon,
} from "@heroicons/react/24/solid";
import { SvgIcon } from "@mui/material";
import { IItems } from "./types";

export const lg: IItems[] = [
  {
    title: "Licensee (LN)",
    path: "/lg/licensee",
    icon: (
      <SvgIcon fontSize="small">
        <ClipboardDocumentListIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Fws Pools",
    path: "/lg/fws-pools",
    icon: (
      <SvgIcon fontSize="small">
        <CubeIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Tws Pools",
    path: "/lg/tws-pools",
    icon: (
      <SvgIcon fontSize="small">
        <CubeTransparentIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Trainers (SL)",
    path: "/lg/trainers",
    icon: (
      <SvgIcon fontSize="small">
        <DocumentDuplicateIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Customers (EZB)",
    path: "/lg/customers",
    icon: (
      <SvgIcon fontSize="small">
        <AcademicCapIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Module Codes",
    path: "/lg/module-codes",
    icon: (
      <SvgIcon fontSize="small">
        <BriefcaseIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Modules",
    path: "/lg/modules",
    icon: (
      <SvgIcon fontSize="small">
        <PresentationChartBarIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Module Course",
    path: "/lg/module-course",
    icon: (
      <SvgIcon fontSize="small">
        <BookOpenIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Orders",
    path: "/lg/orders",
    icon: (
      <SvgIcon fontSize="small">
        <ShoppingCartIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Cancellations",
    path: "/lg/cancel-request",
    icon: (
      <SvgIcon fontSize="small">
        <ArchiveBoxXMarkIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Questionnaire",
    path: "/lg/questions",
    icon: (
      <SvgIcon fontSize="small">
        <QuestionMarkCircleIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Admins",
    path: "/lg/admin-profile",
    icon: (
      <SvgIcon fontSize="small">
        <UserCircleIcon />
      </SvgIcon>
    ),
  },
  {
    title: "My Profile",
    path: "/profile",
    icon: (
      <SvgIcon fontSize="small">
        <UserIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Settings",
    path: "/lg/settings",
    icon: (
      <SvgIcon fontSize="small">
        <CogIcon />
      </SvgIcon>
    ),
  },
];
